import { Navigate, useLoaderData } from 'react-router';
import CompatibilityIssues from '@/components/home/compatibility-issues';
import LoadingLayout from '@/components/layouts/progress-layout/loading-layout';
import ROUTES from '@/routes';
import type { HomeRouteLoaderData } from '@/routes/home.loader';

export default function HomeRoute() {
  const loaderData = useLoaderData<HomeRouteLoaderData>();

  return (
    <main className='w-full bg-gradient items-stretch h-screen-safe max-h-dvh flex-center'>
      <LoadingLayout promise={loaderData.promises}>
        {(data) => {
          if (data?.isCompatibilityChecked) {
            if (data.isBrowserCompatible) {
              if (data.isAuthenticated) {
                return (
                  <Navigate
                    replace
                    to={ROUTES.MESSAGES.$path()}
                  />
                );
              }

              return (
                <Navigate
                  replace
                  to={ROUTES.AUTH.SIGN_IN.$path()}
                />
              );
            }
          }

          if (data?.isBrowserCompatible) {
            return (
              <Navigate
                replace
                to={ROUTES.MESSAGES.$path()}
              />
            );
          }

          return <CompatibilityIssues />;
        }}
      </LoadingLayout>
    </main>
  );
}
